<div class="info-column" matTooltip="{{ cell.value | displayTranslation }}">
  {{ cell.value | displayTranslation }}
</div>
